/**
 * Cuentas de analitica por tenant.
 *
 * Cada cliente white-label tiene (o tendra) su propia propiedad: mezclarlos en
 * una sola cuenta falsea los informes de todos. El tenant sale de
 * REACT_APP_LAYOUT en tiempo de build, igual que en layout.config.ts.
 *
 * Tenant sin `measurementId` = analitica apagada para ese build: no se carga
 * gtag.js ni se envia ningun evento. Es el estado por defecto hasta que el
 * cliente nos pase su ID, y es preferible a mandar sus datos a la cuenta de
 * otro.
 *
 * Las variables de entorno REACT_APP_GA_MEASUREMENT_ID y REACT_APP_GTM_ID
 * mandan sobre la configuracion del tenant, para pruebas o para un despliegue
 * puntual sin tocar codigo.
 */

import { isProduction } from '@/config/environment.config'

export interface AnalyticsConfig {
  /** ID de medicion de GA4 (G-XXXXXXXX). Vacio = sin analitica. */
  measurementId: string
  /** Contenedor de Google Tag Manager (GTM-XXXXXXX). Vacio = sin GTM. */
  gtmId: string
}

const hlaConfig: AnalyticsConfig = {
  measurementId: 'G-01WKPSMDF5',
  gtmId: 'GTM-5Q47GRHK'
}

// Pendientes de que cada cliente nos pase su propia propiedad.
const deloniaConfig: AnalyticsConfig = {
  measurementId: '',
  gtmId: ''
}

const nuevaMutuaSanitariaConfig: AnalyticsConfig = {
  measurementId: '',
  gtmId: ''
}

const hospitalesConfig: AnalyticsConfig = {
  measurementId: '',
  gtmId: ''
}

function getTenantConfig (): AnalyticsConfig {
  switch (process.env.REACT_APP_LAYOUT) {
    case 'hla':
      return hlaConfig
    case 'delonia':
      return deloniaConfig
    case 'nueva-mutua-sanitaria':
      return nuevaMutuaSanitariaConfig
    default:
      return hospitalesConfig
  }
}

const SIN_ANALITICA: AnalyticsConfig = { measurementId: '', gtmId: '' }

export function getAnalyticsConfig (): AnalyticsConfig {
  // Fuera de produccion no se envia nada: el trafico de dev y de local
  // ensuciaba la propiedad real del cliente. Para probar la analitica en dev,
  // pasar REACT_APP_GA_MEASUREMENT_ID a mano, que sigue mandando.
  const tenant = isProduction() ? getTenantConfig() : SIN_ANALITICA

  return {
    measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID ?? tenant.measurementId,
    gtmId: process.env.REACT_APP_GTM_ID ?? tenant.gtmId
  }
}
